import React from 'react';
import { SortIcon } from './SortIcon';
import { StyledTH } from './TH.styled';
import { hoverClassName, StyledTHSortButton, StyledTHSortText, StyledTHSortWrapper } from './THSort.styled';
export function THSort(props) {
  var contentAlign;
  var style = {
    textAlign: props.textAlign,
    width: props.width
  };
  switch (props.textAlign) {
    case 'right':
      contentAlign = {
        justifyContent: 'flex-end'
      };
      break;
    case 'center':
      contentAlign = {
        justifyContent: 'center'
      };
      break;
  }
  return /*#__PURE__*/React.createElement(StyledTH, {
    style: style,
    "aria-sort": props.ariaSort,
    isHidden: props.hidden
  }, /*#__PURE__*/React.createElement(StyledTHSortButton, {
    onClick: function onClick() {
      return props.sort({
        key: props.sortKey,
        direction: props.initialDirection
      });
    }
  }, /*#__PURE__*/React.createElement(StyledTHSortWrapper, {
    isHidden: props.hidden,
    style: contentAlign
  }, /*#__PURE__*/React.createElement(StyledTHSortText, {
    className: hoverClassName
  }, props.children), "\u2002", /*#__PURE__*/React.createElement(SortIcon, {
    sortKey: props.sortKey,
    sortParams: props.sortParams
  }))));
}